OT.createNS('OT.Redesign.Views.TableCategories');

var TAB_KEY = 9;

OT.Redesign.Views.TableCategories = function() {
  $('[data-table-categories]').on('click', function(event) {
    var $selected_timeslot = $(this);
    var tableCategories = $selected_timeslot
      .data('table-categories')
      .split(',')
      .map(function(x) { return x.toLowerCase(); });
    var baseLink = $selected_timeslot.data('href');

    if (tableCategories.length === 1) {
      var category = tableCategories[0];
      if (category === 'hightop') {
        category = 'highTop';
      }
      window.location.href = baseLink + '&tc=' + category;
      return;
    }

    function closeModal() {
      var $overlay = $('#table-categories-overlay');
      $overlay.hide();
      $selected_timeslot.focus();
    }

    function initOverlay() {
      $('#table-categories-overlay').on('click', closeModal).on('click', '.table-selector', function(e) {
        e.stopPropagation();
      });
    }

    function showOverlay() {
      var $overlay = $('#table-categories-overlay');
      $overlay.show();
      $overlay.find("#table-selector-label").focus();
    }

    function initDefaultCategory() {
      var $standardSlotButton = $('#table-categories-overlay .category-row[data-standard-category="true"] .right');
      var $offScreenText = $standardSlotButton.find(".off-screen");
      var hasDefaultTableCategory = tableCategories.indexOf("default") !== -1;

      if (hasDefaultTableCategory) {
        $standardSlotButton.text($standardSlotButton.closest('.table-selector-content').data('select-translation'));
        $standardSlotButton.append($offScreenText);
        $standardSlotButton.attr('href', baseLink + $standardSlotButton.data('href-addon'));
        $standardSlotButton.addClass('category-button button').removeClass('unavailable-text');
      } else {
        $standardSlotButton.text($standardSlotButton.closest('.table-selector-content').data('unavailable-translation'));
        $standardSlotButton.append($offScreenText);
        $standardSlotButton.attr('href', '');
        $standardSlotButton.addClass('unavailable-text').removeClass('category-button button');
      }
    }

    function initNonDefaultCategories() {
      var selector = '[data-standard-category="false"]';
      $('#table-categories-overlay .category-row' + selector).each(function() {
        var $this = $(this);
        var $button = $this.find('.category-button');
        if (tableCategories.indexOf($this.data('category')) !== -1) {
          $button.attr('href', baseLink + $button.data('href-addon'));
          $this.show();
        } else {
          $this.css('display', 'none');
          $this.find('.category-button').removeAttr('href');
        }
      });
    }

    function initLastVisibleCategory() {
      var visibleCategories = $('#table-categories-overlay .category-row:not([style*="display: none"])');
      visibleCategories.each(function(index) {
        var isLastCategory = index === (visibleCategories.length - 1);
        if (isLastCategory) {
          var $selectButton = $(this).find('.category-button');
          $selectButton.attr('data-last-category', 'true');
        }
      });
    }

    function initCloseButton() {
      $('.modal-close').on('click', closeModal);
    }

    function trapFocus() {
      var $lastCategory = $('#table-categories-overlay .category-button[data-last-category="true"]');
      var $closeButton = $('.modal-close');
  
      $lastCategory.on('keydown', function(e) {
        if(!e.shiftKey && e.which === TAB_KEY) {
          e.preventDefault();
          $closeButton.focus();
        }
      });
      $closeButton.on('keydown', function(e) {  
        if(e.shiftKey && e.which === TAB_KEY) { 
          e.preventDefault();
          $lastCategory.focus();
        }
      });
    }

    initOverlay();
    initDefaultCategory();
    initNonDefaultCategories();
    initLastVisibleCategory();
    initCloseButton();
    trapFocus();
    showOverlay();
  });
  $('[data-table-categories]:first').attr('id', 'clicky-tc-test-timeslot');
  //made to open modal for acceptance tests
};
